var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('BRow', {
    staticClass: "mb-3"
  }, [_c('BCol', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.noMetadata ? _c('div', [_c('p', [_vm._v("Geen gegevens beschikbaar.")])]) : _c('BTableSimple', {
    attrs: {
      "small": ""
    }
  }, [_c('colgroup', [_c('col'), _c('col')]), _c('BTbody', _vm._l(_vm.salesOrderMetadata, function (metadata, index) {
    return _c('b-tr', {
      key: index
    }, [_c('b-th', {
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v(_vm._s(metadata.name))]), _c('b-td', [_vm._v(_vm._s(metadata.value))])], 1);
  }), 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }